import { GetIdeaResponse, PutIdeaType } from '@orbit/api-types'
import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUpdateIdea = () => {
	const queryClient = useQueryClient()

	return useMutation<
		GetIdeaResponse,
		Error,
		{ tripId: string; ideaId: string; ideaData: PutIdeaType }
	>({
		mutationFn: async ({ ideaId, ideaData }) => {
			const response = await api.patch<GetIdeaResponse>(`/ideas/${ideaId}`, ideaData)
			return response.data
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['ideas', variables.tripId] })
		},
	})
}
